<template>
  <div class="timers">
    <div class="past-time">
      <div id="timerset">Past Time</div>
      <div id="timerset bottom"><span style="font-size: 30px;">{{ pastTime }}</span></div>
    </div>
    <div class="remaining-time">
      <div class="title">Remaining Time</div>
      <div class="time"><span style="font-size: 30px !important; color: red">{{ remainingTime }}</span></div>
    </div>
  </div>
</template>

<script>
import {
  db
} from '../../../firebase'
import {
  mapGetters
} from 'vuex'

let timeInterval
export default {
  name: 'remaining-time',
  data: () => ({
    remainingTime: '00:00',
    pastTime: '00:00',
    status: '',
    currentTime: '',
    toggle: false
  }),
  computed: mapGetters({
    race: 'Race/race'
  }),
  methods: {
    async initialize() {
      let that = this
      //call first time
      this.listenStartTimeFirebase()

      timeInterval = setInterval(async function () {
        // if (that.toggle) {
        that.listenStartTimeFirebase()
        await that.updateRaceStatusIfNeeded()
        // }
      }, 1000)
    }, async updateRaceStatusIfNeeded() {
      //console.log("updateRaceStatusIfNeeded - start")
      //db.ref(`/${this.$fbDbEntry}/${this.$route.params.raceId}/currentTime`)
      const raceStatusSnapshot = await db.ref(`${this.$fbDbEntry}/${this.$route.params.raceId}/status`).once('value')
      const raceStatus = raceStatusSnapshot.val()

      const currentSecondsSnapshot = await db.ref(`${this.$fbDbEntry}/${this.$route.params.raceId}/currentTime`).once("value")
      const currentSeconds = currentSecondsSnapshot.val()

      // const seconds = raceDuration * 60 * 1000;
      //console.log("updateRaceStatusIfNeeded values: ", raceDuration, then, seconds);
      const raceDuration = this.race.duration * 60
      // Check if raceStatus is RUNNING and currentSeconds is either not set (null) or less than or equal to 0
      if (raceStatus && raceStatus.toString().toUpperCase() === "RUNNING" && (currentSeconds === null || currentSeconds <= 0)) {
        await db.ref(`${this.$fbDbEntry}/${this.$route.params.raceId}`).update({
          'currentTime': raceDuration
        })
        console.log("###################################################################")
        console.log("updateRaceStatusIfNeeded - done >> " + raceDuration)
        console.log("###################################################################")
      } else {
        //console.log("updateRaceStatusIfNeeded - skipped!!!!!!!!!!!!!")
      }
    },
    convertHoursToHuman(secondsToConvert) {
      let hours = Math.floor((secondsToConvert % 86400) / 3600)
      // let minutes = Math.floor((secondsToConvert % 86400) % 3600 / 60)
      let minutes = Math.floor(secondsToConvert / 60)
      let seconds = secondsToConvert % 60 < 10 ? `0${secondsToConvert % 60}` : secondsToConvert % 60

      hours = hours < 10 ? `0${hours}` : hours
      minutes = minutes < 10 ? `0${minutes}` : minutes

      return `${minutes}:${seconds}`
    },
    listenStartTimeFirebase() {
      db.ref(`/${this.$fbDbEntry}/${this.$route.params.raceId}/currentTime`)
          .once('value', (snapshot) => {
            this.currentTime = snapshot.val()
            if (this.currentTime > -1) {
              this.startCountDownFromFB(this.currentTime)
            } else {
              this.startCountDownFromFB(null)
            }
          })
    },
    startCountDownFromFB(startDateTime) {
      //console.log("startCountDownFromFB called")
      if (this.race.duration && startDateTime != null) {
        console.log("startCountDownFromFB + startDatetime")
        this.remainingTime = this.convertHoursToHuman(startDateTime)
        this.pastTime = this.convertHoursToHuman(this.race.duration * 60 - startDateTime)
        this.toggle = true
      } else {
        //console.log("startCountDownFromFB + this.race.duration")
        this.remainingTime = this.convertHoursToHuman(this.race.duration * 60)
        this.pastTime = this.convertHoursToHuman(0)
        this.toggle = true
      }
    }
  },
  watch: {},
  created() {
    clearInterval(timeInterval)
    this.initialize()
  }
}
</script>



// WEBPACK FOOTER //
// RemainingTime.vue?052d4de7